import {
  Transaction,
  TransactionBankTransferStatus,
  TransactionStatus,
} from '../../__generated__/GQL';

const isPendingTransactionValidated = ({
  bankTransferStatus,
  status,
}: Pick<Transaction, 'bankTransferStatus' | 'status'>) =>
  status === TransactionStatus.Pending &&
  bankTransferStatus === TransactionBankTransferStatus.SentToSepaNetwork;

export default isPendingTransactionValidated;
